import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueTyperPlugin from 'vue-typer'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import CoolLightBox from 'vue-cool-lightbox'

import {VueMasonryPlugin} from 'vue-masonry';

import Unicon from 'vue-unicons/dist/vue-unicons-vue2.umd'
import { 
  uniLayerGroupMonochrome, 
  uniCarWash,
  uniApple,
  uniGooglePlay,
  uniStarMonochrome,
  uniDownloadAltMonochrome,
  uniGithubMonochrome,
  uniExternalLinkAlt
} 
  from 'vue-unicons/dist/icons'
import ReadMore from 'vue-read-more';

Unicon.add([
  uniLayerGroupMonochrome, 
  uniCarWash,
  uniApple,
  uniGooglePlay,
  uniStarMonochrome,
  uniDownloadAltMonochrome,
  uniGithubMonochrome,
  uniExternalLinkAlt
]);

Vue.use(VueMasonryPlugin);
Vue.use(Unicon);
Vue.use(CoolLightBox);
Vue.use(Buefy);
Vue.use(VueTyperPlugin);
Vue.use(ReadMore);

Vue.config.productionTip = false

new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
